module.exports = __webpack_public_path__ + "static/media/26import-55.410fb2f1.xlsx";